// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file container.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContainerGroup, ContainerGroupJson, ContainerType, ContainerTypeJson } from "./container_group_pb";
import { file_container_group } from "./container_group_pb";
import type { ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Job, JobJson } from "./job_pb";
import { file_job } from "./job_pb";
import type { PickupLocation, PickupLocationJson } from "./pickup_location_pb";
import { file_pickup_location } from "./pickup_location_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file container.proto.
 */
export const file_container: GenFile = /*@__PURE__*/
  fileDesc("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", [file_container_group, file_general, file_google_protobuf_timestamp, file_job, file_pickup_location]);

/**
 * @generated from message raccoonai.Container
 */
export type Container = Message<"raccoonai.Container"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string name = 2;
   */
  name: string;

  /**
   * @generated from field: required uint64 type_id = 3 [json_name = "type_id"];
   */
  typeId: bigint;

  /**
   * @generated from field: required raccoonai.ContainerType type = 4;
   */
  type?: ContainerType;

  /**
   * @generated from field: required raccoonai.ContainerStatus status = 5;
   */
  status: ContainerStatus;

  /**
   * @generated from field: required uint64 owner_organization_id = 6 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required bool is_tracked = 7 [json_name = "is_tracked"];
   */
  isTracked: boolean;

  /**
   * @generated from field: optional uint64 pickup_location_id = 8 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: optional raccoonai.ContainerTrackingEvent last_event = 9 [json_name = "last_event"];
   */
  lastEvent: ContainerTrackingEvent;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_event_at = 10 [json_name = "last_event_at"];
   */
  lastEventAt?: Timestamp;

  /**
   * @generated from field: optional raccoonai.ContainerGroup container_group = 11 [json_name = "container_group"];
   */
  containerGroup?: ContainerGroup;

  /**
   * The job that last moved or serviced this container. Backend-written only.
   *
   * @generated from field: optional uint64 last_job_id = 12 [json_name = "last_job_id"];
   */
  lastJobId: bigint;

  /**
   * last_job_id preloaded, on the reads that preload it.
   *
   * @generated from field: optional raccoonai.Job last_job = 13 [json_name = "last_job"];
   */
  lastJob?: Job;

  /**
   * pickup_location_id preloaded, so a list does not need a call per location.
   *
   * @generated from field: optional raccoonai.PickupLocation pickup_location = 14 [json_name = "pickup_location"];
   */
  pickupLocation?: PickupLocation;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.Container
 */
export type ContainerJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string name = 2;
   */
  name?: string;

  /**
   * @generated from field: required uint64 type_id = 3 [json_name = "type_id"];
   */
  type_id?: string;

  /**
   * @generated from field: required raccoonai.ContainerType type = 4;
   */
  type?: ContainerTypeJson;

  /**
   * @generated from field: required raccoonai.ContainerStatus status = 5;
   */
  status?: ContainerStatusJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 6 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required bool is_tracked = 7 [json_name = "is_tracked"];
   */
  is_tracked?: boolean;

  /**
   * @generated from field: optional uint64 pickup_location_id = 8 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: optional raccoonai.ContainerTrackingEvent last_event = 9 [json_name = "last_event"];
   */
  last_event?: ContainerTrackingEventJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_event_at = 10 [json_name = "last_event_at"];
   */
  last_event_at?: TimestampJson;

  /**
   * @generated from field: optional raccoonai.ContainerGroup container_group = 11 [json_name = "container_group"];
   */
  container_group?: ContainerGroupJson;

  /**
   * The job that last moved or serviced this container. Backend-written only.
   *
   * @generated from field: optional uint64 last_job_id = 12 [json_name = "last_job_id"];
   */
  last_job_id?: string;

  /**
   * last_job_id preloaded, on the reads that preload it.
   *
   * @generated from field: optional raccoonai.Job last_job = 13 [json_name = "last_job"];
   */
  last_job?: JobJson;

  /**
   * pickup_location_id preloaded, so a list does not need a call per location.
   *
   * @generated from field: optional raccoonai.PickupLocation pickup_location = 14 [json_name = "pickup_location"];
   */
  pickup_location?: PickupLocationJson;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.Container.
 * Use `create(ContainerSchema)` to create a new message.
 */
export const ContainerSchema: GenMessage<Container, {jsonType: ContainerJson}> = /*@__PURE__*/
  messageDesc(file_container, 0);

/**
 * @generated from message raccoonai.ContainerCreate
 */
export type ContainerCreate = Message<"raccoonai.ContainerCreate"> & {
  /**
   * @generated from field: required string name = 1;
   */
  name: string;

  /**
   * @generated from field: required uint64 type_id = 2 [json_name = "type_id"];
   */
  typeId: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional uint64 pickup_location_id = 4 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: optional bool is_tracked = 5 [json_name = "is_tracked"];
   */
  isTracked: boolean;

  /**
   * @generated from field: optional raccoonai.ContainerTrackingEvent last_event = 6 [json_name = "last_event"];
   */
  lastEvent: ContainerTrackingEvent;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_event_at = 7 [json_name = "last_event_at"];
   */
  lastEventAt?: Timestamp;

  /**
   * @generated from field: optional uint64 container_group_id = 8 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;
};

/**
 * @generated from message raccoonai.ContainerCreate
 */
export type ContainerCreateJson = {
  /**
   * @generated from field: required string name = 1;
   */
  name?: string;

  /**
   * @generated from field: required uint64 type_id = 2 [json_name = "type_id"];
   */
  type_id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional uint64 pickup_location_id = 4 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: optional bool is_tracked = 5 [json_name = "is_tracked"];
   */
  is_tracked?: boolean;

  /**
   * @generated from field: optional raccoonai.ContainerTrackingEvent last_event = 6 [json_name = "last_event"];
   */
  last_event?: ContainerTrackingEventJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_event_at = 7 [json_name = "last_event_at"];
   */
  last_event_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 container_group_id = 8 [json_name = "container_group_id"];
   */
  container_group_id?: string;
};

/**
 * Describes the message raccoonai.ContainerCreate.
 * Use `create(ContainerCreateSchema)` to create a new message.
 */
export const ContainerCreateSchema: GenMessage<ContainerCreate, {jsonType: ContainerCreateJson}> = /*@__PURE__*/
  messageDesc(file_container, 1);

/**
 * @generated from message raccoonai.ContainerUpdate
 */
export type ContainerUpdate = Message<"raccoonai.ContainerUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional uint64 type_id = 4 [json_name = "type_id"];
   */
  typeId: bigint;

  /**
   * @generated from field: optional raccoonai.ContainerStatus status = 5;
   */
  status: ContainerStatus;

  /**
   * @generated from field: optional bool is_tracked = 6 [json_name = "is_tracked"];
   */
  isTracked: boolean;

  /**
   * @generated from field: optional uint64 pickup_location_id = 7 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: optional raccoonai.ContainerTrackingEvent last_event = 8 [json_name = "last_event"];
   */
  lastEvent: ContainerTrackingEvent;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_event_at = 9 [json_name = "last_event_at"];
   */
  lastEventAt?: Timestamp;

  /**
   * @generated from field: optional uint64 container_group_id = 10 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;
};

/**
 * @generated from message raccoonai.ContainerUpdate
 */
export type ContainerUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional uint64 type_id = 4 [json_name = "type_id"];
   */
  type_id?: string;

  /**
   * @generated from field: optional raccoonai.ContainerStatus status = 5;
   */
  status?: ContainerStatusJson;

  /**
   * @generated from field: optional bool is_tracked = 6 [json_name = "is_tracked"];
   */
  is_tracked?: boolean;

  /**
   * @generated from field: optional uint64 pickup_location_id = 7 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: optional raccoonai.ContainerTrackingEvent last_event = 8 [json_name = "last_event"];
   */
  last_event?: ContainerTrackingEventJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_event_at = 9 [json_name = "last_event_at"];
   */
  last_event_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 container_group_id = 10 [json_name = "container_group_id"];
   */
  container_group_id?: string;
};

/**
 * Describes the message raccoonai.ContainerUpdate.
 * Use `create(ContainerUpdateSchema)` to create a new message.
 */
export const ContainerUpdateSchema: GenMessage<ContainerUpdate, {jsonType: ContainerUpdateJson}> = /*@__PURE__*/
  messageDesc(file_container, 2);

/**
 * @generated from message raccoonai.ContainerStatusUpdate
 */
export type ContainerStatusUpdate = Message<"raccoonai.ContainerStatusUpdate"> & {
  /**
   * @generated from field: required string name = 1;
   */
  name: string;

  /**
   * @generated from field: required uint64 pickup_location_id = 2 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: required raccoonai.ContainerTrackingEvent last_event = 3 [json_name = "last_event"];
   */
  lastEvent: ContainerTrackingEvent;

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * The job being executed when the container moved; must belong to
   * owner_organization_id. Omitted leaves the stored job in place.
   *
   * @generated from field: optional uint64 job_id = 5 [json_name = "job_id"];
   */
  jobId: bigint;
};

/**
 * @generated from message raccoonai.ContainerStatusUpdate
 */
export type ContainerStatusUpdateJson = {
  /**
   * @generated from field: required string name = 1;
   */
  name?: string;

  /**
   * @generated from field: required uint64 pickup_location_id = 2 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: required raccoonai.ContainerTrackingEvent last_event = 3 [json_name = "last_event"];
   */
  last_event?: ContainerTrackingEventJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * The job being executed when the container moved; must belong to
   * owner_organization_id. Omitted leaves the stored job in place.
   *
   * @generated from field: optional uint64 job_id = 5 [json_name = "job_id"];
   */
  job_id?: string;
};

/**
 * Describes the message raccoonai.ContainerStatusUpdate.
 * Use `create(ContainerStatusUpdateSchema)` to create a new message.
 */
export const ContainerStatusUpdateSchema: GenMessage<ContainerStatusUpdate, {jsonType: ContainerStatusUpdateJson}> = /*@__PURE__*/
  messageDesc(file_container, 3);

/**
 * @generated from message raccoonai.ContainerList
 */
export type ContainerList = Message<"raccoonai.ContainerList"> & {
  /**
   * @generated from field: repeated raccoonai.Container containers = 1;
   */
  containers: Container[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.ContainerList
 */
export type ContainerListJson = {
  /**
   * @generated from field: repeated raccoonai.Container containers = 1;
   */
  containers?: ContainerJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.ContainerList.
 * Use `create(ContainerListSchema)` to create a new message.
 */
export const ContainerListSchema: GenMessage<ContainerList, {jsonType: ContainerListJson}> = /*@__PURE__*/
  messageDesc(file_container, 4);

/**
 * *****************************************************
 * CONTAINER
 * *****************************************************
 *
 * @generated from enum raccoonai.ContainerStatus
 */
export enum ContainerStatus {
  /**
   * @generated from enum value: CONTAINER_STATUS_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: CONTAINER_STATUS_INACTIVE = 1;
   */
  INACTIVE = 1,

  /**
   * @generated from enum value: CONTAINER_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,
}

/**
 * *****************************************************
 * CONTAINER
 * *****************************************************
 *
 * @generated from enum raccoonai.ContainerStatus
 */
export type ContainerStatusJson = "CONTAINER_STATUS_UNDEFINED" | "CONTAINER_STATUS_INACTIVE" | "CONTAINER_STATUS_ACTIVE";

/**
 * Describes the enum raccoonai.ContainerStatus.
 */
export const ContainerStatusSchema: GenEnum<ContainerStatus, ContainerStatusJson> = /*@__PURE__*/
  enumDesc(file_container, 0);

/**
 * @generated from enum raccoonai.ContainerTrackingEvent
 */
export enum ContainerTrackingEvent {
  /**
   * @generated from enum value: CONTAINER_TRACKING_EVENT_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: CONTAINER_TRACKING_EVENT_DELIVERED = 1;
   */
  DELIVERED = 1,

  /**
   * @generated from enum value: CONTAINER_TRACKING_EVENT_COLLECTED = 2;
   */
  COLLECTED = 2,
}

/**
 * @generated from enum raccoonai.ContainerTrackingEvent
 */
export type ContainerTrackingEventJson = "CONTAINER_TRACKING_EVENT_UNDEFINED" | "CONTAINER_TRACKING_EVENT_DELIVERED" | "CONTAINER_TRACKING_EVENT_COLLECTED";

/**
 * Describes the enum raccoonai.ContainerTrackingEvent.
 */
export const ContainerTrackingEventSchema: GenEnum<ContainerTrackingEvent, ContainerTrackingEventJson> = /*@__PURE__*/
  enumDesc(file_container, 1);

